// extracted by mini-css-extract-plugin
export default {"label":"Label_label__8yJJW"};